import Modal from "../../../../components/modalWindow/modal";
import ButtonField from '../../../../components/buttonField/buttonField';
import { classNameBtn } from '../../../../components/shared/button/types/buttonProps';
import { GeometrySummaryProps } from "./types/geometrySummaryProps";
import { ReactComponent as polyline } from '../../../../icons/polyline.svg';
import { useContext, useEffect, useState } from "react";
import Spinner from "../../../../components/spinner/spinner";
import { apiContext } from "../../../../contexts/apiContext";
import { GeometrySummary, SummaryCount } from "../../../../services/geometryService/types/geometryServiceProps";
import './uploadGeometrySummary.scss';

const UploadGeometrySummary = (props: GeometrySummaryProps) => {
    const [loading, setLoading] = useState<boolean>(true);
    const [summary, setSummary] = useState<GeometrySummary | null>(null);
    const { apiUrl, apiVersion } = useContext(apiContext);

    useEffect(() => {
        if (props.error) {
            var geometrySummary: GeometrySummary = {
                success: false,
                errors: [props.error]
            }
            setSummary(geometrySummary);
            setLoading(false);
        }
        else {
            // const query = makeCancelable(GetSummary(props.jobId, apiUrl, apiVersion));
            // query.promise.then((res) => {
            //     setSummary(res as GeometrySummary);
            //     setLoading(false);
            // }, (err) => {
            //     setLoading(false);
            // });

            const getCountKr = (value: any[], type?: string, type2?: string) => {
                var count = 0;
                for (var i = 0; i < value.length; i++) {
                    if (value[i].wzor_kr === type) {
                        count++;
                    }
                    if (type2 && value[i].wzor_kr === type2){
                        count++;
                    }
                }
                return count;
            }

            const getCountContour = (value: any[], uniqueIds: any[]) => {
                var czola = 0;
                var granicE_OSUWISK = 0;
                //var liniA_AZYMUT = 0;
                var progI_AKUMULACYJNE = 0;
                var rowy = 0;
                var rumosze = 0;
                var skarpY_GLOWNE = 0;
                var skarpY_WTORNE = 0;
                var strefY_AKTYWNOSCI = 0;
                var szczeliny = 0;
                var wodY_POWIERZCHNIOWE = 0;
                var wodY_PUNKTOWE = 0;
                var zaglebienia = 0;
                for (var i = 0; i < uniqueIds.length; i++) {
                    var objects = value[uniqueIds[i].id];
                    czola += objects.czola.obj_amount;
                    granicE_OSUWISK += objects.granicE_OSUWISK.obj_amount;
                    //liniA_AZYMUT += objects.liniA_AZYMUT.obj_amount;
                    progI_AKUMULACYJNE += objects.progI_AKUMULACYJNE.obj_amount;
                    rowy += objects.rowy.obj_amount;
                    rumosze += objects.rumosze.obj_amount;
                    skarpY_GLOWNE += objects.skarpY_GLOWNE.obj_amount;
                    skarpY_WTORNE += objects.skarpY_WTORNE.obj_amount;
                    strefY_AKTYWNOSCI += objects.strefY_AKTYWNOSCI.obj_amount;
                    szczeliny += objects.szczeliny.obj_amount;
                    wodY_POWIERZCHNIOWE += objects.wodY_POWIERZCHNIOWE.obj_amount;
                    wodY_PUNKTOWE += objects.wodY_PUNKTOWE.obj_amount;
                    zaglebienia += objects.zaglebienia.obj_amount;
                }
                return [
                    { name: "Strefy aktywności", count: strefY_AKTYWNOSCI },
                    { name: "Granice osuwisk", count: granicE_OSUWISK },
                    { name: "Skarpy główne", count: skarpY_GLOWNE },
                    { name: "Skarpy wtórne", count: skarpY_WTORNE },
                    { name: "Rowy", count: rowy },
                    { name: "Czoła", count: czola },
                    { name: "Progi akumulacyjne", count: progI_AKUMULACYJNE },
                    { name: "Szczeliny", count: szczeliny },
                    { name: "Zagłębienia", count: zaglebienia },
                    { name: "Rumosze", count: rumosze },
                    { name: "Wody punktowe", count: wodY_PUNKTOWE },
                    { name: "Wody powierzchniowe", count: wodY_POWIERZCHNIOWE },
                ]
            }

            if (props.summary !== undefined && props.summary !== null && props.summary.isValid !== undefined && props.summary.isValid === true) {
                var summaryCount: SummaryCount[] = [
                    { name: "Osuwiska", count: props.summary.osuw_amount },
                ]
                summaryCount = summaryCount.concat(getCountContour(props.summary.related_objects_for_osuw, props.summary.osuw_unique_ids))
                summaryCount.push({ name: "Tereny zagrożone", count: props.summary.tz_amount });

                var geometrySummary2: GeometrySummary = {
                    success: true,
                    contours: summaryCount,
                    krs: [
                        { name: "KRO 2020", count: getCountKr(props.summary.osuw_unique_ids, "2", "2020") },
                        { name: "KRTZ 2020", count: getCountKr(props.summary.tz_unique_ids, "2") },
                        { name: "KRO 2007", count: getCountKr(props.summary.osuw_unique_ids, "1") },
                        { name: "KRTZ 2007", count: getCountKr(props.summary.tz_unique_ids, "1") }
                    ]
                }
                setSummary(geometrySummary2);
            }
            setLoading(false);
        }
    }, [apiUrl, apiVersion, props.jobId, props.error, props, props.summary])

    const handleClose = () => {
        props.onClose();
    }

    const renderSummary = (items: GeometrySummary | null) => {
        if (props.jobId === '' && items?.success === false && props.error !== '') {
            return <div className="summaryErrorRow">
                {renderSummaryErrors(['Ładowanie geometrii zostało przerwane'])}
            </div>
        }
        if (items !== null && items.success) {
            return <div>
                <h3>Liczba załadowanych obiektów:</h3>
                {renderSummaryCount(items.contours)}
                <h3>Liczba utworzonych KR:</h3>
                {renderSummaryCount(items.krs)}
            </div>
        }
        if (items !== null && items.success === false) {
            return <div className="summaryErrorRow">
                {renderSummaryErrors(items.errors)}
            </div>
        }
        return <div>Niepowodzenie podczas pobierania podsumowania</div>
    }

    const renderSummaryCount = (items?: SummaryCount[]) => {
        return <table>
            {items?.map((item, index) => {
                return <tr key={index}><td>{item.name}</td><td style={{ width: '100px' }}>{item.count}</td></tr>
            })}
        </table>
    }

    const renderSummaryErrors = (errors?: string[]) => {
        return errors?.map((item, index) => {
            return <div key={index}>{item}</div>
        })
    }

    return (<Modal
        title="Podsumowanie wgrywania"
        titleIcon={polyline}
        width='520px'
        height='410px'
        actionBtns={[
            <ButtonField
                key={1}
                BtnProps={{
                    onClick: handleClose,
                    className: `${classNameBtn.Btn} ${classNameBtn.Large} body-txt-medium`
                }}
                placeHolder="Zamknij"
            />
        ]}
        onClose={handleClose}>
        <div className="geometrySummaryContainer">
            {loading ? <Spinner /> : renderSummary(summary)}
        </div>
    </Modal>);
};

export default UploadGeometrySummary;